import axios from 'axios';
import { openAPIErrorCallback } from 'api/callbacks';
import { V1_AUTHORIZED_APPS_URL, V1_AUTHORIZED_APP_BY_ID } from './constants';

export function getAuthorizedAppsV1({ userId, params }) {
  return axios
    .get(V1_AUTHORIZED_APPS_URL({ userId }), { params, withCredentials: true })
    .catch(openAPIErrorCallback);
}

export function deleteAuthorizedAppsV1({ userId, appId, params }) {
  return axios
    .delete(V1_AUTHORIZED_APP_BY_ID({ userId, appId }), {
      params,
      withCredentials: true,
    })
    .catch(openAPIErrorCallback);
}
